import React, { useState, useEffect } from 'react';

const ConfirmModal = ({
  isOpen,
  message,
  onConfirm,
  onCancel,
  requireLaborHours = false
}) => {
  const [laborHours, setLaborHours] = useState('');

  useEffect(() => {
    if (isOpen) setLaborHours('');
  }, [isOpen]);

  if (!isOpen) return null;

  const handleConfirm = () => {
    if (requireLaborHours && !laborHours) return;
    onConfirm(requireLaborHours ? Number(laborHours) : undefined);
  };

  return (
    <div className="tt-modal-backdrop">
      <div className="tt-modal" style={{ maxWidth: '380px' }}>
        <div className="tt-modal-header">
          <h3 className="tt-modal-title">{message}</h3>
        </div>

        <div className="tt-modal-body">
          {requireLaborHours && (
            <div>
              <label>Actual Labor Hours</label>
              <input
                type="number"
                step="0.1"
                autoFocus
                value={laborHours}
                onChange={(e) => setLaborHours(e.target.value)}
                className="tt-input"
                placeholder="e.g. 5.5"
              />
            </div>
          )}
        </div>

        <div className="tt-modal-footer">
          <button
            onClick={onCancel}
            className="tt-button tt-button--ghost"
          >
            Cancel
          </button>

          <button
            onClick={handleConfirm}
            className="tt-button tt-button--primary"
          >
            Complete
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
